export default {
  data() {
    return {
      allOptions: {},
      loading: false
    }
  },
  created() {
    this.getSoftProductConfig();
  },
  methods: {
    getSoftProductConfig() {
      this.loading = true;
      this.$q.newProduct.getSoftProductConfig()
      .then(res=>{
        this.allOptions = res.data;
      })
      .finally(_=>{
        this.loading = false;
      })
    }
  }
}